import { useState } from 'react';
import { useProjectContext } from '~/hooks';
import { Header } from 'semantic-ui-react';
import { PricingEstimateProposalType } from '~/constants';
import PricingEstimateProposalButton from './PricingEstimateProposalButton';
import CustomerProposalModal from '~/modals/CustomerProposalModal';
import { ReactComponent as ConductorLogo } from '~/assets/logo.svg';
import '../styles.scss';

export default function SavingsAnalysisTable({ isPriceEstimateStale }: { isPriceEstimateStale?: boolean }) {
  const { project, projectAutopricing, projectState } = useProjectContext();
  const [modalOpen, setModalOpen] = useState(false);

  type ProposalButtonType = 'DEFAULT' | 'PPA' | 'LEASE';
  const projectProposalType = project?.customerProposal?.proposalType as ProposalButtonType;
  const [proposalButtonType, setProposalButtonType] = useState<ProposalButtonType>(projectProposalType ? projectProposalType : 'DEFAULT');

  const handleClick = (newState: ProposalButtonType) => {
    if (proposalButtonType === 'DEFAULT') {
      setModalOpen(true);
    }
    setProposalButtonType(newState);
  };

  return (
    <div className="savings-analysis-container">
      <Header as="h2">Savings analysis</Header>
      {(project?.contractType === 'PPA' || projectState?.isQuote) && (

        <div>

          <div className="savings-analysis">
            <div className="estimate-item">
              <span className="estimate-value"> {projectAutopricing?.netSavingsPercentageRange?.netSavingsRange}</span>
              <span className="estimate-label">Net savings percentage</span>
            </div>
            <div className="estimate-item">
              <span className="estimate-value">{projectAutopricing?.currentPricing?.ppaCurrentPricing}</span>
              <span className="estimate-label">Avoided cost of power</span>
            </div>
            <div className="estimate-item">
              <span className="estimate-value">{projectAutopricing?.solarContract?.ppaSolarContract}</span>
              <span className="estimate-label">PPA rate, year 1</span>
            </div>
            <div className="estimate-item">
              <span className="estimate-value">{projectAutopricing?.netSavingsValueRange?.ppaNetSavings}</span>
              <span className="estimate-label">Net savings</span>
            </div>
            {projectState?.isQuote && (
              <div>
                {(proposalButtonType === 'DEFAULT' || proposalButtonType === 'PPA') && (
                  <PricingEstimateProposalButton
                    isPriceEstimateStale={!!isPriceEstimateStale}
                    proposalType={PricingEstimateProposalType.PPA}
                    onClick={() => handleClick('PPA')}
                  />
                )}
              </div>
            )}
            <div className="powered-by">
              <span>Powered by</span> <ConductorLogo />
            </div>
          </div>

        </div>
      )}

      {modalOpen &&
        <CustomerProposalModal
          closeModal={() => setModalOpen(false)}
          proposalType={proposalButtonType === 'PPA' ? PricingEstimateProposalType.PPA : PricingEstimateProposalType.LEASE}
          setProposalButtonType={setProposalButtonType}
        />
      }
    </div>
  );
}